import { Injectable } from '@angular/core';
import { Http, Response, RequestOptions, Headers } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../../environments/environment';
import { Router } from "@angular/router";
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { SignUpUser } from '../../shared/classes/sign-up-user';
import { User } from '../../shared/classes/user';

@Injectable()
export class UserService {
  user: SignUpUser = <SignUpUser>{};
  tokensUrl = environment.tokensUrl;
  employeeInfoUrl = environment.employeeInfoUrl;
  currentUser: User;

  constructor(private http: Http, private router: Router) {
  }

  login(user: any): Observable<any> {
    let headers = new Headers({ Accept: 'application/jwt' })
    let options = new RequestOptions({ headers: headers });
    return this.http.post(this.tokensUrl, user, options)
      .map(res => res)
  }

  getEmployeeInfo(empId: number): Observable<any> {
    let headers = new Headers({ Authorization: localStorage.token, Accept: 'application/vnd.api+json' })
    let options = new RequestOptions({ headers: headers });
    return this.http.get(`${this.employeeInfoUrl}${empId}?include=organization`, options)
      .map(res => res.json())
  }

  logOut(): Observable<any> {
    let headers = new Headers({ 'Authorization': `Bearer ${localStorage.onboardingToken}` });
    let options = new RequestOptions({ headers: headers });

    localStorage.clear();
    this.currentUser = undefined;

    return this.http
      .delete(environment.onboardingTokenUrl, options)
      .map(res => res.json());
  }

  signUp(user: SignUpUser): Observable<any> {
    let data = { user };
    return this.http.post(environment.signUpUrl, data)
      .map(res => res.json())
  }

  onboardingLogin(user: any): Observable<any> {
    return this.http.post(environment.onboardingTokenUrl, user)
      .map(res => res.json())
  }

  getUserInfo(): Observable<any> {
    let headers = new Headers({ 'Authorization': `Bearer ${localStorage.onboardingToken}` })
    let options = new RequestOptions({ headers: headers });
    return this.http.get(environment.userInfoUrl, options)
      .map(res => {
        this.setCurrentUser(res.json());
        return res.json();
      })
  }

  setCurrentUser(json) {
    this.currentUser = User.toUser(json);
  }

  isLoggedIn(): boolean {
    return !!((localStorage.token && localStorage.userEmail && localStorage['lscache-currentUser']) || (localStorage.onboardingToken && localStorage.onboardingUser));
  }

  sendConfirmation(token: string) {
    return this.http.get(`${environment.confirmationTokenUrl}${token}`)
      .map(res => res.json())
  }

  saveSignUpUser(user: SignUpUser) {
    this.user = user;
  }

  getSignUpUser() {
    return this.user;
  }

  getPasswordResetEmail(email: string) {
    return this.http.post(environment.resetPasswordUrl, { user: { email } })
      .map(res => res.json())
  }

  resetPassword(data: any) {
    return this.http.put(environment.resetPasswordUrl, data)
      .map(res => res.json())
  }

  updateUser(userId: number, info: any) {
    let data = { user: info };
    let headers = new Headers({ 'Authorization': `Bearer ${localStorage.onboardingToken}` })
    let options = new RequestOptions({ headers: headers });
    return this.http.put(`${environment.usersUrl}/${userId}.json`, data, options)
      .map(res => res.json())
  }

  updatePassword(userId: number, info: any) {
    let data = { user: info };
    let headers = new Headers({ 'Authorization': `Bearer ${localStorage.onboardingToken}` })
    let options = new RequestOptions({ headers: headers });
    return this.http.put(`${environment.usersUrl}/${userId}/update_password.json`, data, options)
      .map(res => res.json())
  }

  checkEmailExist(email: string) {
    let data = { user: { email } };
    return this.http.post(environment.attemptUrl, data)
      .map(res => res.json());
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/user.service.ts